<template>
  <div class="people-list">
    <grid-row>
      <div
        v-for="(person, i) in items"
        :key="i"
        :class="`people-list__item--${ type(person) }`"
        class="people-list__item"
      >
        <border-box :xs-hide="!person" class="people-list__item-box">
          <grid-row class="people-list__item-row">
            <div class="people-list__item-inner">
              <person-box
                v-if="person"
                :photo="person.photo"
                :name="person.name"
                :position="person.position"
                :description="person.description"
                :phone="person.phone"
                :email="person.email"
              />
            </div>
          </grid-row>
        </border-box>
      </div>
    </grid-row>
  </div>
</template>

<script>
import zip from 'lodash/zip'
import flatten from 'lodash/flatten'

import PersonBox from '@/containers/Team/PersonBox'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    PersonBox,
    BorderBox
  },
  props: {
    people: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    items () {
      const leftColumn = this.people.filter(person => person.column === 'left')
      const rightColumn = this.people.filter(person => person.column === 'right')
      const columnLength = Math.max(leftColumn.length, rightColumn.length)
      const createColumn = (arr, length) => Array(length).fill({}).map((_, i) => arr[i] || false)
      return flatten(zip(
        createColumn(leftColumn, columnLength), createColumn(rightColumn, columnLength)
      ))
    },
    type () {
      return ({ column }) => column === 'right' ? 'even' : 'odd'
    }
  }
}
</script>

<style lang="scss" scoped>
  .people-list {
    &__item {
      @include grid-column((xs: 12, md: 6));

      &-inner {
        @include grid-column((xs: 12));
      }

      @include media-up(lg) {
        &--odd {
          @include nested-column-width(4, 9, lg);
        }

        &--even {
          @include nested-column-width(5, 9, lg);
        }

        &--even &-inner {
          @include nested-column-width(4, 5, lg);
        }
      }

      &-box,
      &-row {
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Team/PeopleList.vue